import React from 'react';
import axios from "axios";
import { useState } from 'react';
import { Button, Form, FloatingLabel, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';


    const GstSoftware = () => {
        const [name, setName] = useState('')
        const [email, setEmail] = useState('')
        const [number, setNumber] = useState('')
        const [company, setCompany] = useState('')
        const [statusCode, setStatusCode] = useState('')
        const [message, setMessage] = useState('')
    
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    
  const API_PATH = 'http://amosta.com/reactJs/GSTsoftwarw.php';
  function axios2() {

    axios({
      method: 'post',
      url: API_PATH,
      headers: {
        'content-type': 'application/json'

      },
      data: {
        "name": name,
        "email": email,
        "number": number,
        "company": company

      }
    })
      .then(result => {
        if (result.data.statusCode === 200) {
          setStatusCode(result.data.statusCode)
          setMessage(result.data.message)
          window.location.reload(false)
        } else {
          setStatusCode(result.data.statusCode)
          setMessage(result.data.message)
        }
        console.log(result);
      })
      .catch(error => {
        console.log(error)
      });
  }

    return (
        <div>
            <img className='img-fluid gst-software-main-banner' src="./assets/images/gst-application-banner.jpg" alt="" />
            <div className="container gst-software-section-2">
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <h2 className=''>GST Return Filing Made Simple</h2>
                        <div className="container mt-5">
                            <ul>
                                <li>Claim 100% Accurate Input Tax Credit</li>
                                <li>Reconcile E-Way Bill Data with GST Returns</li>
                                <li>File Errorless GST Returns</li>
                                <li>Smart Dashboard for Real-Time Analytics</li>
                            </ul>

                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="container gst-software-first-form p-5 bg-white text-dark text-center border-0 rounded-2 shadow-lg w-75" style={{ marginTop: '150px' }}>
                        <h5>{statusCode}</h5>
                        <h5>{message}</h5>
                            <Form autoComplete="off">
                                <h3 className='mb-3'>Request a Call</h3>
                                <FloatingLabel controlId='fullName' label='Full Name' className='mb-3'>
                                    <Form.Control type='text' placeholder='Full Name' id='name' name="name" onChange={(e) => setName(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='phone' label='Mobile Number' className='mb-3'>
                                    <Form.Control type='number' placeholder='Phone number' id='number' name="number" onChange={(e) => setNumber(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='emailId' label='Email Id' className='mb-3'>
                                    <Form.Control type='email' placeholder='name@example.com' id='email' name="email" onChange={(e) => setEmail(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='companyName' label='Company Name' className='mb-3'>
                                    <Form.Control type='text' placeholder='Company Name' id='company' name="company" onChange={(e) => setCompany(e.target.value)} required />
                                </FloatingLabel>
                                <Button type="button" onClick={axios2} className='text-center mt-3' variant='success'>Submit</Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container section-3-gst-software">
                <h1>GST Software</h1>
                <p align='justify'>With One Nation, One Tax - GST is considered as transformative thing in the era of the Digitization of Indian Economy. GST has created optimism for businesses by replacing multiple taxes with a uniform tax on supply chain of goods and services.</p>
                <p align='justify'>GST has led to a complete overhaul of the current indirect tax system and there are numerous updates and developments that has come with this new tax regime. To ensure your business remains GST optimized and compliant, it is very important to understand and stay up-to-date of all these new developments.</p>
                <p align='justify'>We have a wide range of customized and easy to use GST software and GST APIs to help you manage your GST processes and GST risks.</p>
            </div>

            <div className="container section-4-gst-software mt-5 bg-light p-5">
                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <img className='img-fluid' src="./assets/images/gst-application-in.png" alt="" />
                    </div>
                    <div className="col-sm-12 col-md-8">
                        <h2>GST Software</h2>
                        <p className='mt-4' align='justify'>Our GST Software enables its end users to do filing of GST returns seamlessly with GST compliances and rules. GST software and application from GSTrobo® which has various data validation checks to ensure data accuracy without any manual intervention. It allows you to create and send E-invoices and comes with a Light Weight Mobile Application.</p>
                        <Button className='mt-3' variant='warning' onClick={handleShow}>Schedule a Demo</Button>

                        <Modal show={show} onHide={handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>Request a Callback</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form autoComplete="off">
                                    <FloatingLabel controlId='fullName' label='Full Name' className='mb-3'>
                                        <Form.Control type='text' placeholder='Full Name' id='fullName' required />
                                    </FloatingLabel>
                                    <FloatingLabel controlId='phone' label='Mobile Number' className='mb-3'>
                                        <Form.Control type='number' placeholder='Phone number' id='phone' required />
                                    </FloatingLabel>
                                    <FloatingLabel controlId='emailId' label='Email Id' className='mb-3'>
                                        <Form.Control type='email' placeholder='name@example.com' id='emailId' required />
                                    </FloatingLabel>
                                    <FloatingLabel controlId='companyName' label='Company Name' className='mb-3'>
                                        <Form.Control type='text' placeholder='Company Name' id='companyName' required />
                                    </FloatingLabel>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" className='me-auto' onClick={handleClose}>
                                    Submit
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div>
            </div>

            <div className="container section-5-gst-software mt-5 p-3 text-center">
                <h2>Key Features of GST Software - GSTrobo</h2>
                <div className="section-5-gst-software-cards mt-5 p-3">

                    <div className="row">
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3 w-25' src="./assets/images/auto-returns.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Auto - populate returns with Zero Error</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/tax (1).png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Multi-business, multi-location return filing from a single login</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/integration.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Seamless Integration with all ERP's</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/claim.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Claim 100% ITC through GSTrobo Reconciliation</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/invoice (1).png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>100% GST compliant E-invoices</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/reconcile (1).png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Reconcile E-Way Bill data with GST Returns</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/financial.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Get GST business insight reports for the entire financial year</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/ledger (1).png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Electronic Cash, Credit and Liability Ledger</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/dashboard.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Interactive and Easy Dashboards</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/return-filing.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Annual Return Filing</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/real-time-reports.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Real-time analytics reports & MIS</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/bulk-data.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Bulk download and upload of data</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/cloud-based.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Cloud Based Platform</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/multiple-login.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Multiple GSTIN Login</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container gstrobo-section-3 bg-light mt-5 text-center pb-5">
                <h1 className='pt-5'><span style={{ color: '#f43f47' }}>GST</span> Products</h1>
                <p className='text-muted'>Ensuring Compliance, Reliability & Efficiency</p>
                <div className="gstrobo-cards">
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/invoice.png" alt="" />
                        <h4 className='mt-3'>GST Software</h4>
                        <Link to='/gst-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/real-time-goods.png" alt="" />
                        <h4 className='mt-3'>E-Way Bill Software</h4>
                        <Link to='/e-way-bill-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/one-click-icon.png" alt="" />
                        <h4 className='mt-3'>E-Invoicing Software</h4>
                        <Link to='/e-invoicing-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/api.png" alt="" />
                        <h4 className='mt-3'>GST & E-Way Bill API</h4>
                        <Link to='/gst-e-way-bill-api'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/reconcile.png" alt="" />
                        <h4 className='mt-3'>Intelligence Insight</h4>
                        <Link to='/intelligence-insight'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/ledger.png" alt="" />
                        <h4 className='mt-3'>Value Added Tools</h4>
                        <Link to='/value-added-tools'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default  GstSoftware;
